import { constants } from '../../constants';

const styles = {
    avatarStyle: {
        // marginTop: 30,
    },
    backgroundImageStyle: {
        alignItems: 'stretch',
        backgroundImage: 'url(http://via.placeholder.com/1x1)',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        minHeight: `calc(100vh - 80px)`,
        transition: 'all 0.5s ease-in-out',
    },
    buttonStyle: {
        marginBottom: 30,
        marginTop: 30,
    },
    contentContainerStyle: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        ...constants.layout.contentWidth,
    },
    imageOverlay: {
        alignItems: 'center',
        backgroundColor: 'rgba(0,0,0,0.4)',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        paddingBottom: 40,
        paddingTop: 25,
    },
    mainTitleStyle: {
        color: 'white',
        fontFamily: 'Open Sans',
        fontSize: 40,
        fontWeight: '700',
        marginBottom: 10,
        marginTop: 15,
        textAlign: 'left',
    },
    subTitleStyle: {
        color: 'white',
        fontSize: 24,
        fontWeight: '200',
        marginBottom: 20,
        marginTop: 0,
    },
    titleContainer: {
        // This set the orientation of the title headers relative to eachother
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        transition: 'all 0.5s ease-in-out',
    },
}

export { styles as heroStyles };



// WEBPACK FOOTER //
// ./src/js/components/Hero/styles.ts